/*
  Service actions
*/
// Libraries
import { apollo } from '@/plugins/apollo'

// graphql files
import list from 'GraphQL/queries/requisitions/list.gql'

const dayjs = require('dayjs')

export default {
  async getList ({ state, dispatch, commit, rootState }, payload = false) {
    if (payload) {
      commit('setLoading', true, { root: true })
    }

    await apollo.query({
      query: list,
      variables: {
        apiToken: rootState.users.entity.apiToken,
        startAt: dayjs().add(-15, 'day').unix(),
        endAt: dayjs().unix()
      },
      fetchPolicy: 'no-cache'
    }).then((response) => {
      const { status, result } = response.data.requisitions

      switch (status) {
        case 'OK':
          commit('setRequisitions', result)
          break

        case 'UNPROCESSABLE':
          commit('toggleSnackbar', undefined, { root: true })
          break
      }
    }).catch((error) => {
      commit('toggleSnackbar', undefined, { root: true })
    }).finally(() => {
      if (payload) {
        commit('setLoading', false, { root: true })
      }
    })
  }
}
